<div class="ui vertical basic segment" appMargin marginB="5">
  <div class="ui two column grid">
    <div class="column middle aligned">
      <h2 class="ui primary header link">Notification Center</h2>
    </div>
    <div class="column right aligned">
      <!-- <button class="ui primary button" (click)="newTemplate()">New Template</button> -->
    </div>
  </div>
</div>

<!-- <div class="ui vertical basic segment" style="border: 3px solid #f2f2f2;"> -->
<!-- Search toolbar -->
<div class="ui vertical basic segment">
  <app-search-filter
    [filter]="searchParams"
    (onSearch)="searchRecords($event)"
    (onDisplayRows)="onDisplayRecords($event)"
    (onSort)="sortRecords($event)"
  ></app-search-filter>
</div>

<div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
  <div
    *ngFor="let notification of notifications"
    class="ui segment"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="15px"
  >
    <div fxFlex="2%">
      <span
        class="ui circular mini red label"
        *ngIf="notification.read != true"
      ></span>
    </div>

    <div fxFlex="5%" style="padding-left: 15px">
      <i
        class="large envelope outline icon"
        [ngClass]="{ open: notification.read == true }"
      ></i>
    </div>

    <div fxFlex="grow">
      <sui-accordion [closeOthers]="false">
        <sui-accordion-panel [isOpen]="true">
          <div
            title
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <div
              appMargin
              marginY="2"
              class="ui primary header"
              style="width: 40%"
            >
              {{ notification.subject }}
            </div>
            <div class="stay-right" style="width: 40%">
              <div fxFlex="70%" fxLayout="column" fxLayoutAlign="center">
                <div class="description">Date</div>
                <div>
                  {{
                    notification.dateCreated
                      | amLocale: "en"
                      | amDateFormat: "MMMM Do YYYY, h:mm a"
                  }}
                  <!-- {{notification.dateCreated | date:'mediumDate'}}< -->
                </div>
              </div>
              <div fxFlex="15%">
                <button
                  *ngIf="notification.read == false"
                  class="ui circular basic tiny button"
                  (click)="MarkasRead(notification)"
                  suiPopup
                  popupText="Mark as read"
                >
                  <i class="ui white check icon"></i>
                </button>
              </div>
              <div>
                <button class="ui circular basic tiny button">
                  <i class="dropdown icon"></i>
                </button>
              </div>
            </div>
          </div>
          <div
            content
            class="sub-item"
            [innerHTML]="notification.body"
            appMargin
            marginB="2"
          ></div>
        </sui-accordion-panel>
      </sui-accordion>
      <!-- <div appMargin marginY="2" class="ui primary header">
        {{ notification.subject }}
      </div>
      <div
        class="sub-item"
        [innerHTML]="notification.body"
        appMargin
        marginB="2"
      ></div> -->
    </div>
  </div>

  <bpp-no-record-found
    *ngIf="notifications && notifications.length < 1"
  ></bpp-no-record-found>
  <bpp-no-record-found *ngIf="!notifications"></bpp-no-record-found>
</div>

<div class="ui vertical basic segment">
  <div class="ui two column grid">
    <div class="column middle aligned">
      <div class="ui medium labeled button">
        <div class="ui icon button">
          <i class="database icon"></i>
        </div>
        <a class="ui basic label"> {{ total }} Record(s) </a>
      </div>
    </div>
    <div class="column right aligned pagination menu">
      <sui-pagination
        class="small"
        [collectionSize]="total"
        [pageSize]="records"
        [maxSize]="maxSize"
        [page]="page"
        (pageChange)="nextPage($event)"
      >
      </sui-pagination>
    </div>
  </div>
</div>
